/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { VALUES } from "../../utils/constants";
import MaterialIcon from "../materialIcon/materialIcon";
import { Scrollbars } from "react-custom-scrollbars";
import clsx from "clsx";
import {
  makeStyles,
  ListItem,
  useTheme,
  Divider,
  List,
  ListItemText,
  Drawer,
  IconButton,
  Grid,
  Collapse,
} from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import HomeIcon from "@material-ui/icons/Home";
import Logo from "../../images/logoZabug.jpeg";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { useStateValue } from "../../context/store";
import { menuDataResponse } from "./jsonMenu";
import autoeval from "../../images/icons/Autoeval.svg"

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: VALUES.MENU.DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    minHeight: "47px!important",
  },
  textMenu: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
    letterSpacing: "-0.05px",
    color: "#4B4B4B",
    "&:hover": {
      color: "#4B4B4B",
    },
    paddingRight: 15
  },
  nested: {
    paddingLeft: theme.spacing(6),
    color: "#66788A",
    "&:hover": {
      background: "#F7F7F7",
      color: "#ffffff",
    },
  },
  nestedTwo: {
    paddingLeft: theme.spacing(7),
    "&:hover": {
      background: "#F7F7F7",
      color: "#ffffff",
    },
  },
  menuHover: {
    padding: "0px",
  },
  menuHoverOpen: {
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
      color: "#ffffff",
      borderRadius: 10,
      "& $iconHover": {
        color: "#4D8D9D",
      },
    },
  },
  menuHoverClose: {
    color: "#ffffff",
    "&:hover": {
      background: "#ffffff",
      color: "#ffffff",
      "& $iconHover": {
        color: "#4D8D9D",
        background: "#ffffff",
      },
    },
  },
  iconHover: {
    color: "#4D8D9D",
  },
  iconsExpan: {
    color: "#4B4B4B",
    marginRight: 10,
  },
  myComponent: {
    "& .MuiIconButton-root": {
      padding: 10
    }
  }
}));

const LeftMenu = (props) => {
  const [{ breadCrumb }] = useStateValue();
  const [{ }, dispatch] = useStateValue();
  const classes = useStyles();
  const theme = useTheme();
  const [access, setAccess] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState({});
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleListItemClick = (index, breadCrumb) => {
    setSelectedIndex(index);
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: breadCrumb,
      index: index,
    });
    setAnchorEl(null);
  };

  const handleClick = (el) => {
    const target = el.currentTarget;
    setOpen((prev) => ({
      ...prev,
      [target.getAttribute("name")]: !prev[target.getAttribute("name")],
    }));
  };

  useEffect(() => {
    intialPermissions();
    setSelectedIndex(breadCrumb?.index);
  }, [breadCrumb?.index]);

  const intialPermissions = () => {
    const allAccess = [];

    const state = localStorage.getItem("state");
    let permissions = JSON.parse(state)?.permissions;

    const unicos = permissions?.filter((valor, indice) => {
      return permissions?.indexOf(valor) === indice;
    });

    const mapCode = unicos?.map((x) => allAccess.push(x.code));
    setAccess(allAccess);
  };

  const url = "/dashboard";

  return (
    <React.Fragment key="left">
      <Drawer
        anchor="left"
        open={props.isOpen.left}
        onClose={props.toggleDrawer("left", false)}
      >
        <div className={classes.toolbar}>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{ display: "flex", alignItems: "center" }}
          >
            <IconButton
              style={{ color: "#646464" }}
              onClick={props.toggleDrawer("left", false)}
            >
              <Menu />
            </IconButton>
            <img
              src={Logo}
              width="100"
              height="29"
              alt=""
              style={{ paddingLeft: "20px" }}
            />
          </Grid>

          <IconButton
            onClick={props.toggleDrawer("left", false, "Inicio")}
            style={{ color: "#4D8D9D", margin: "0px 30px" }}
          >
            <HomeIcon />
          </IconButton>
        </div>
        <Divider />

        <Scrollbars
          style={{
            width: "auto",
            height: "inherit",
            backgroundColor: "#ffffff",
          }}
        >
          <List component="div" disablePadding>
            {menuDataResponse
              ? menuDataResponse.menus.map((menu, index) => (
                <React.Fragment key={index}
                  onClick={() => props.toggleDrawer("left", false)}
                >
                  {menu.breadCrumbText &&
                    (menu?.code === "HV" || menu?.code === "VAC" ||
                      access?.includes(menu?.code) ||
                      access?.includes(menu?.c1Code)) &&
                    !menu?.subMenus && (
                      <div
                        onClick={props.toggleDrawer("left", false)}
                        onKeyDown={props.toggleDrawer("left", false)}
                      >

                        {menu.icon !== "autoeval" &&
                          <ListItem
                            className={clsx(classes.menuHover, {
                              [classes.menuHoverOpen]: props.isOpen,
                              [classes.menuHoverClose]: !props.isOpen,

                            },classes.myComponent)}
                            to={`${url}${menu.url}`}
                            component={Link}
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            selected={selectedIndex === menu?.index}
                            onClick={() => {
                              handleListItemClick(
                                menu.index,
                                menu.breadCrumbText
                              );
                            }}
                          >
                            <IconButton className={classes.iconHover}>
                              <MaterialIcon fill="outlined" name={menu.icon} />
                            </IconButton>
                            <ListItemText
                              className={classes.textMenu}
                              primary={menu.title}
                            />
                          </ListItem>
                        }
                        {menu.icon === "autoeval" &&
                          <ListItem
                            className={clsx(classes.menuHover, {
                              [classes.menuHoverOpen]: props.isOpen,
                              [classes.menuHoverClose]: !props.isOpen,
                            })}
                            to={menu.url}
                            component="a"
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            selected={selectedIndex === menu?.index}
                            onClick={() => {
                              handleListItemClick(
                                menu.index,
                                menu.breadCrumbText
                              );
                            }}
                          >
                            <a href={menu.url} target="_blank" style={{ cursor: "pointer", marginLeft: "10px" }}> <img src={autoeval} alt="Autoevaluaciones" style={{ width: "25px" }} /></a>
                            <ListItemText
                              style={{ cursor: "pointer", marginLeft: "9px" }}
                              className={classes.textMenu}
                              primary={menu.title}
                              onClick={() => {
                                window.open('https://g-pull-front-dot-sae-dev.appspot.com/auth/login')
                              }}
                            />
                          </ListItem>
                        }
                      </div>
                    )}
                  {(access?.includes(menu?.code) ||
                    access?.includes(menu?.c1Code)) &&
                    menu?.subMenus ? (
                    <React.Fragment>
                      <ListItem
                        button
                        name={menu.title}
                        className={clsx(classes.menuHover, {
                          [classes.menuHoverOpen]: props.isOpen,
                          [classes.menuHoverClose]: !props.isOpen,
                        })}
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        selected={selectedIndex === menu?.index}
                        onClick={handleClick}
                      >
                        <IconButton className={classes.iconHover}>
                          <MaterialIcon fill="outlined" name={menu.icon} />
                        </IconButton>
                        <ListItemText
                          className={classes.textMenu}
                          primary={menu.title}
                        />
                        {open[menu.title] ? (
                          <ExpandMoreOutlinedIcon
                            className={classes.iconsExpan}
                          />
                        ) : (
                          <KeyboardArrowLeftIcon
                            className={classes.iconsExpan}
                          />
                        )}
                      </ListItem>

                      {menu?.subMenus?.map((sub, index) => (
                        <React.Fragment
                          key={index}
                          onClick={() => props.toggleDrawer("left", false)}
                        >
                          {access?.includes(sub?.code) && (
                            <Collapse
                              in={
                                open[menu.title]
                                  ? props.isOpen
                                  : open[menu.title]
                              }
                              timeout="auto"
                              unmountOnExit
                              className={clsx(classes.menuHover, {
                                [classes.menuHoverOpen]: props.isOpen,
                                [classes.menuHoverClose]: !props.isOpen,
                              })}
                              aria-controls="simple-menu"
                              aria-haspopup="true"
                              onClick={props.toggleDrawer("left", false)}
                            >
                              <List component="div" disablePadding>
                                <ListItem
                                  to={`${url}${sub.url}`}
                                  component={Link}
                                  selected={selectedIndex === sub?.index}
                                  onClick={() =>
                                    handleListItemClick(
                                      sub.index,
                                      sub.breadCrumbText
                                    )
                                  }
                                >
                                  <ListItemText
                                    style={{ marginLeft: "20%" }}
                                    className={classes.textMenu}
                                    primary={sub.title}
                                  />
                                </ListItem>
                              </List>
                            </Collapse>
                          )}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : null}
                </React.Fragment>
              ))
              : null}
          </List>
        </Scrollbars>
      </Drawer>
    </React.Fragment>
  );
};

export default withRouter(React.memo(LeftMenu));
